module.exports = __webpack_public_path__ + "img/412-5d1c84.png";